import { FC, ReactNode } from 'react';
import { Box, useTheme } from '@mui/material';

interface ScrollbarProps {
  className?: string;
  children?: ReactNode;
  style?: React.CSSProperties;
}

const Scrollbar: FC<ScrollbarProps> = ({ className, children, style, ...rest }) => {
  const theme = useTheme();

  return (
    <Box
      className={className}
      sx={{
        overflowY: 'auto',
        overflowX: 'hidden',
        '&::-webkit-scrollbar': {
          width: '5px',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: theme.colors.alpha.black[10],
          borderRadius: theme.general.borderRadiusLg,
          '&:hover': {
            backgroundColor: theme.colors.alpha.black[30],
          },
        },
        height: "100%",
        ...style,
      }}
      {...rest}
    >
      {children}
    </Box>
  );
};

export default Scrollbar;
